import { ISignpost } from '../models';

export function fromJsonApi(data: any): ISignpost {

    const { attributes: { name, content } } = data.data.data;

    return {
        name,
        content,
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/signposts.ts